<template>
  <HeaderScrim class="events-scrim" data-testid="events-scrim" @close="emits('close')" />
  <!-- A wrapper positions the panel: Events' root carries the unlayered global
       .add-processing { position: relative }, which beats any layered rule set on it.
       Its own click (an update picked) closes it, as the scrim does. -->
  <div class="events-panel" data-testid="events-panel">
    <LazyPortalEvents @click="emits('close')" />
  </div>
</template>

<script setup lang="ts">
import HeaderScrim from '~/components/layout/header/HeaderScrim.vue'
import { useBreakpoints } from '~/composables/display'

// The demonstrator's mobile Events panel and its scrim (nuxt2 parity). The header
// mounts it while open and owns the flag and the page scroll lock; this closes itself
// when it is no longer wanted, as MobileMenu does for the drawer. AB#63680
const emits = defineEmits<{
  (e: 'close'): void
}>()

const route = useRoute()
const { breakpoints } = useBreakpoints()

// Opening scrolls to the top, so the panel hangs from the header in view.
onMounted(() => {
  window.scrollTo({ top: 0 })
})

watch(() => route.path, () => emits('close'))
// The bullhorn is hidden from md up, so close when the viewport crosses it (rotation,
// window resize); otherwise the panel stays open with no button and the page locked.
watch(() => breakpoints.mdAndUp.value, (mdAndUp) => {
  if (mdAndUp) { emits('close') }
})
</script>

<style lang="scss" scoped>
// nuxt2's values. The panel hangs below the sticky .nav-component, its containing
// block; the scrim sits under the header's navbar (z-index 11), so the header stays
// usable.
.events-scrim {
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
}

.events-panel {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  bottom: auto;
  // Content height, capped to the viewport: the dimmed area below the content must
  // stay scrim, so a tap there closes the panel. dvh follows mobile Safari's URL bar.
  max-height: 100vh;
  max-height: 100dvh;
  overflow-y: auto;
  z-index: 12;
}
</style>
